document.addEventListener('DOMContentLoaded', function () {
  const recoveryFaqItems = document.querySelectorAll(
    '.recovery-faq-item'
  );

  recoveryFaqItems.forEach(function (item) {
    const question = item.querySelector(
      '.recovery-faq-question'
    );

    if (!question) return;

    question.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      recoveryFaqItems.forEach(function (faqItem) {
        faqItem.classList.remove('is-open');

        const faqQuestion = faqItem.querySelector(
          '.recovery-faq-question'
        );

        if (faqQuestion) {
          faqQuestion.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      });

      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute(
          'aria-expanded',
          'true'
        );
      }
    });
  });
});